package com.ervasstudio.tracoemovimento.worker

import com.varabyte.kobweb.worker.Attachments
import com.varabyte.kobweb.worker.WorkerContext
import org.w3c.dom.Worker
import kotlin.js.Json
import kotlin.js.json

class EchoWorker(override var onOutput: WorkerContext.(output: com.ervasstudio.tracoemovimento.worker.EchoOutput) -> Unit = {}) :
    com.varabyte.kobweb.worker.Worker<com.ervasstudio.tracoemovimento.worker.EchoInput, com.ervasstudio.tracoemovimento.worker.EchoOutput> {

    private val ioSerializer = com.ervasstudio.tracoemovimento.worker.EchoWorkerFactory().createIOSerializer()

    private val worker = Worker("/_kobweb/workers/com-ervasstudio-tracoemovimento-worker/worker-7e3f.js").apply {
        onmessage = { e ->
            val json = e.data.unsafeCast<Json>()
            val outputDeserialized = try {
                ioSerializer.deserializeOutput(json["_output"] as String)
            } catch (e: Throwable) {
                console.warn(buildString {
                    append("Unable to deserialize output generated by worker, ignoring it.")
                    e.message?.let { append("\nException: $it") }
                })
                null
            }
            if (outputDeserialized != null) {
                val ctx = WorkerContext(Attachments.fromJson(json))
                ctx.onOutput(outputDeserialized)
            }
        }
    }

    override fun postInput(input: com.ervasstudio.tracoemovimento.worker.EchoInput, attachments: Attachments) {
        val inputSerialized = try {
            ioSerializer.serializeInput(input)
        } catch (e: Throwable) {
            console.warn(buildString {
                append("Unable to serialize argument when calling `EchoWorker.postInput(com.ervasstudio.tracoemovimento.worker.EchoInput)`, ignoring the call.")
                e.message?.let { append("\nException: $it") }
            })
            null
        }
        if (inputSerialized != null) {
            worker.postMessage(
                json("_input" to inputSerialized).add(attachments.toJson()),
                attachments.toValues()
            )
        }
    }

    override fun terminate() {
        worker.terminate()
    }
}